import { useQuery } from '@tanstack/react-query'
import { useAuth0 } from '@auth0/auth0-react'
import { apiClient } from '@/api/client'

export function useTeamStats(teamId?: string, timeFilter: string = 'all_time') {
  const { getAccessTokenSilently } = useAuth0()

  return useQuery({
    queryKey: ['team-stats', teamId, timeFilter],
    queryFn: async () => {
      const token = await getAccessTokenSilently({
        authorizationParams: {
          // Temporarily remove audience requirement to test
          // audience: import.meta.env.VITE_AUTH0_AUDIENCE,
          scope: 'openid profile email',
        },
      })
      apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`
      const response = await apiClient.get(`/stats/team/${teamId}?time_filter=${timeFilter}`)
      return response.data
    },
    enabled: !!teamId,
  })
}

export function usePlayerStats(playerId?: string, teamId?: string) {
  const { getAccessTokenSilently } = useAuth0()

  return useQuery({
    queryKey: ['player-stats', playerId, teamId],
    queryFn: async () => {
      const token = await getAccessTokenSilently({
        authorizationParams: {
          // Temporarily remove audience requirement to test
          // audience: import.meta.env.VITE_AUTH0_AUDIENCE,
          scope: 'openid profile email',
        },
      })
      apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`
      const response = await apiClient.get(`/stats/player/${playerId}?team_id=${teamId}`)
      return response.data
    },
    enabled: !!playerId && !!teamId,
  })
}

export function useDuoStats(player1Id?: string, player2Id?: string, teamId?: string) {
  const { getAccessTokenSilently } = useAuth0()

  return useQuery({
    queryKey: ['duo-stats', player1Id, player2Id, teamId],
    queryFn: async () => {
      const token = await getAccessTokenSilently({
        authorizationParams: {
          // Temporarily remove audience requirement to test
          // audience: import.meta.env.VITE_AUTH0_AUDIENCE,
          scope: 'openid profile email',
        },
      })
      apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`
      const response = await apiClient.get(`/stats/duo/${player1Id}/${player2Id}?team_id=${teamId}`)
      return response.data
    },
    enabled: !!player1Id && !!player2Id && !!teamId,
  })
}

export function useGlobalLeaderboard() {
  const { getAccessTokenSilently } = useAuth0()

  return useQuery({
    queryKey: ['global-leaderboard'],
    queryFn: async () => {
      const token = await getAccessTokenSilently({
        authorizationParams: {
          scope: 'openid profile email',
        },
      })
      apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`
      const response = await apiClient.get('/stats/global/leaderboard')
      return response.data
    },
  })
}

export function useGameOfTheDay(teamId?: string) {
  const { getAccessTokenSilently } = useAuth0()

  return useQuery({
    queryKey: ['game-of-the-day', teamId],
    queryFn: async () => {
      const token = await getAccessTokenSilently({
        authorizationParams: {
          scope: 'openid profile email',
        },
      })
      apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`
      const response = await apiClient.get(`/stats/team/${teamId}?time_filter=daily`)
      return response.data.highlighted_game
    },
    enabled: !!teamId,
  })
}

export function useGlobalTeamStats() {
  const { getAccessTokenSilently } = useAuth0()

  return useQuery({
    queryKey: ['global-team-stats'],
    queryFn: async () => {
      const token = await getAccessTokenSilently({
        authorizationParams: {
          scope: 'openid profile email',
        },
      })
      apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`
      const response = await apiClient.get('/stats/global/teams')
      return response.data
    },
  })
}
